var render = function render() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h

  return _c("studip-dialog", {
    attrs: {
      title: _vm.$gettext("Lernmaterial hinzufügen"),
      closeText: _vm.$gettext("Schließen"),
      closeClass: "cancel",
      height: "320",
      width: "680",
    },
    on: {
      close: function close($event) {
        return _vm.setShowUnitAddDialog(false)
      },
    },
    scopedSlots: _vm._u([
      {
        key: "dialogContent",
        fn: function fn() {
          return [
            _c(
              "div",
              {
                staticClass: "square-button-panel",
              },
              [
                _c("studip-square-button", {
                  attrs: {
                    icon: "add",
                    title: _vm.$gettext("Neu erstellen"),
                  },
                  on: {
                    click: function click($event) {
                      return _vm.selectType("new")
                    },
                  },
                }),
                _vm._v(" "),
                _vm.inCourseContext
                  ? _c("studip-square-button", {
                      attrs: {
                        icon: "schedule",
                        title: _vm.$gettext("Neu, Struktur aus Ablaufplan"),
                      },
                      on: {
                        click: function click($event) {
                          return _vm.selectType("topics")
                        },
                      },
                    })
                  : _vm._e(),
                _vm._v(" "),
                _c("studip-square-button", {
                  attrs: {
                    icon: "copy",
                    title: _vm.$gettext("Bestehendes kopieren"),
                  },
                  on: {
                    click: function click($event) {
                      return _vm.selectType("copy")
                    },
                  },
                }),
                _vm._v(" "),
                _c("studip-square-button", {
                  attrs: {
                    icon: "import",
                    title: _vm.$gettext("Aus Datei importieren"),
                  },
                  on: {
                    click: function click($event) {
                      return _vm.selectType("import")
                    },
                  },
                }),
              ],
              1
            ),
          ]
        },
        proxy: true,
      },
    ]),
  })
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }